import axios from 'axios'
// import qs from 'qs'
import { Message } from 'element-ui'
import router from '@/router'

const Axios = axios.create({
  baseURL: location.href.indexOf('gw.greatssp.com') > -1 ? process.env.API_CN : (location.href.indexOf('gw.yeahtargeter.com') > -1 ? process.env.API_US : process.env.API), // 请求后台地址
  timeout: 60000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    if (config.method === 'post') {
      // 序列化
      // config.data = qs.stringify(config.data)
      // 温馨提示,若是提交能直接接受json 格式,可以不用 qs 来序列化的
    }

    // 若是有做鉴权token , 就给头部带上token
    // 若是需要跨站点,存放到 cookie 会好一点,限制也没那么多,有些浏览环境限制了 localstorage 的使用
    // if (JSON.parse(localStorage.loginUserBaseInfo).token) {
    //   config.headers.Authorization = JSON.parse(localStorage.loginUserBaseInfo).token
    // }
    return config
  },
  error => {
    // error 的回调信息
    Message({
      //  饿了么的消息弹窗组件,类似toast
      showClose: true,
      message: error,
      type: 'error.data.error.message'
    })
    return Promise.reject(error.data.error.message)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    // 若token失效或已经过期，则返回登录页
    if (res.data.code === '000001' || res.data.code === '000003') {
      if (res.data.code === '000003') {
        Message({
          showClose: true,
          message: '登录信息已过期,请重新登录',
          type: 'error'
        })
      }
      router.push({
        path: '/login'
      })
    } else if (!res.data.succeed) {
      // 非token原因下的返回失败
      Message({
        showClose: true,
        message: res.data.msg,
        type: 'error'
      })
      return Promise.reject(res.data.msg)
    }

    return res
  },
  error => {
    // 用户登录的时候会拿到一个基础信息,比如用户名,token,过期时间戳，直接丢localStorage或者sessionStorage
    // 若是没有发现有鉴权的基础信息,直接返回登录页
    if (!window.localStorage.getItem('loginUserBaseInfo')) {
      router.push({
        path: '/login'
      })
    }

    // 返回 response 里的错误信息
    let errorInfo = error.message
      ? error.message
      : error.data.error
        ? error.data.error.message
        : error.data
    Message({
      showClose: true,
      message: errorInfo,
      type: 'error.data.error.message'
    })
    return Promise.reject(errorInfo)
  }
)

export default Axios



// WEBPACK FOOTER //
// ./src/common/request/index.js